var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"container"},[_c('div',{staticClass:"row justify-center"},[_vm._v("Made with"),_c('div',{staticClass:"icon-container"},[_c('icon-heart')],1),_vm._v("by Levi")])])])}
var staticRenderFns = []

export { render, staticRenderFns }